<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-flex tw-justify-between tw-items-center">
        <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Integrations</h1>
        <base-button @click="$refs.integrationSlideOver.show()" class="tw-hidden sm:tw-flex">
          <template #icon>
            <plus-icon />
          </template>
          New Integration
        </base-button>
        <base-icon @click="$refs.integrationSlideOver.show()" class="tw-inline sm:tw-hidden">
          <plus-icon class="tw-h-5 tw-w-5" />
        </base-icon>
      </base-content>
    </div>
    <base-content>
      <base-table :fields="fields" :items="integrations" :loading="isLoading">
        <template #image="{ item: integration }">
          <div class="tw-h-12 tw-w-12">
            <avatar :integration-id="integration.integrationId" avatar-type="integration" />
          </div>
        </template>
        <template #integration="{ item: integration }">
          <div>{{ integration.name }}</div>
          <div class="tw-text-xs tw-text-gray-500">{{ integration.description }}</div>
        </template>
        <template #price="{item: integration }">
          {{ formatCurrency(integration.priceInCents, integration.currency) }}
        </template>
        <template #actions="{item: integration}">
          <div class="tw-flex tw-items-center tw-space-x-2">
            <base-button type="flat" size="sm" @click="$refs.integrationSlideOver.show(integration)">
              <template v-slot:icon>
                <edit-icon />
              </template>
              Edit
            </base-button>
            <base-button @click="$refs.deleteIntegrationModal.show(integration)" type="flat" size="sm">
              <template v-slot:icon>
                <trash-icon />
              </template>
              Delete
            </base-button>
          </div>
        </template>
        <template #loading-row>
          <td class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-12 tw-w-12 tw-rounded-full" /></td>
          <td class="tw-py-3 tw-px-4"><base-skeleton-loader class="tw-h-3 tw-w-60" /><base-skeleton-loader class="tw-h-2 tw-w-24 tw-mt-2" /></td>
          <td class="tw-py-3 tw-px-4" align="right"><base-skeleton-loader class="tw-h-3 tw-w-24" /></td>
          <td class="tw-py-3 tw-px-4">
            <div class="tw-flex tw-space-x-2">
              <base-skeleton-loader class="tw-h-8 tw-w-20" v-for="key in 2" :key="`action-loader-cell-${key}`" />
            </div>
          </td>
        </template>
        <template #empty-state>
          <div class="tw-flex tw-justify-center tw-py-5">
            No Integrations
          </div>
        </template>
      </base-table>
    </base-content>
    <integration-slide-over ref="integrationSlideOver" @integration-updated="handleUpdate" @image-uploaded="getIntegrations" />
    <delete-integration-modal ref="deleteIntegrationModal" @deleted="deleteIntegration" />
  </div>
</template>

<script>
import Avatar from "@/components/Avatar";
import IntegrationSlideOver from "@/views/admin/integrations/components/IntegrationSlideOver";
import DeleteIntegrationModal from "@/views/admin/integrations/components/DeleteIntegrationModal";
import { PlusIcon, EditIcon, TrashIcon } from "@/assets/svgs";

export default {
  components: {
    Avatar,
    IntegrationSlideOver,
    DeleteIntegrationModal,
    PlusIcon,
    EditIcon,
    TrashIcon,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        { title: "Image", key: "image", thClass: "tw-w-0 tw-text-center" },
        { title: "Integration", key: "integration" },
        { title: "Price", key: "price", thClass: "tw-text-right", align: "right" },
        { title: "Actions", key: "actions", thClass: "tw-w-0 tw-text-center" },
      ],
      integrations: [],
    };
  },
  created() {
    this.getIntegrations();
  },
  methods: {
    async getIntegrations() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/integrations`);
        this.integrations = response.data;
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Failed to load integrations",
          message: "We had a problem retrieving the list of integrations. Please reload the page to try again.",
          error,
        });
      } finally {
        this.isLoading = false;
      }
    },
    formatCurrency(cents, currency) {
      return new Intl.NumberFormat(window.navigator.language, { style: "currency", currency: currency }).format(cents / 100);
    },
    handleUpdate(integration) {
      const index = this.integrations.findIndex((i) => i.integrationId === integration.integrationId);
      if (index > -1) {
        this.integrations.splice(index, 1, integration);
      } else {
        this.integrations.push(integration);
      }
    },
    deleteIntegration(integration) {
      const index = this.integrations.findIndex((i) => i.integrationId === integration.integrationId);
      if (index > -1) {
        this.integrations.splice(index, 1);
      }
    },
  },
};
</script>
